$(document).ready(function() {
  setTimeout(function(){
    $('body').append($('.priceActionBottomRight'))
  }, 3000)
   
  //  $('body').append($('.samplesFree'));
})

// Inicializace intervalového ID pro možnost jeho zastavení
let intervalId = null;

function updateSessionStorage(key, value) {
    window.sessionStorage.setItem(key, JSON.stringify(value));
}

function getSessionStorage(key) {
    const value = window.sessionStorage.getItem(key);
    return value ? JSON.parse(value) : null;
}

function updateTimeSpent() {

    let totalTimeSpent = getSessionStorage('totalTimeSpent') || 0;
    totalTimeSpent += 1;
    if (totalTimeSpent >= 90) {
        // Zastaví aktualizaci po dosažení 90 sekund
        clearInterval(intervalId);
        if (!getSessionStorage('formSubmitted')) {
            $('body').append($('.samplesFree'));
            $('#cboxOverlay').show();
        }
        
    }
    updateSessionStorage('totalTimeSpent', totalTimeSpent);
}

window.onload = function() {

    if (!getSessionStorage('formSubmitted')) {
 
        intervalId = setInterval(updateTimeSpent, 1000);
    }
}




$(document).on('click', '.priceActionBottomRight .toggleForm', function(){
    $(this).closest('.priceActionBottomRight').find('.whiteUs').slideToggle()
    $(this).closest('.priceActionBottomRight').toggleClass('openFormFloating')
})

$(document).on('submit', '.priceActionForm', function(e) {
    e.preventDefault();
    $(this).addClass('floatingformLoading')
    var formData = {
      jmeno: $('.priceActionForm input#nameAndSurname').val(),
      firma: $('.priceActionForm input#firm-vat').val(),
      telefon: $('.priceActionForm input#phone').val(),
      email: $('.priceActionForm input#email').val(),
      formtype: 'FLOATING',
      pageUrl: window.location.href,
      message: $('.priceActionForm textarea#message').val(),
      date: getFormattedDate(), // Přidání data odeslání
      time: getFormattedTime()  // Přidání času odeslání
    };

    function getFormattedDate() {
      var now = new Date();
      var day = String(now.getDate()).padStart(2, '0');
      var month = String(now.getMonth() + 1).padStart(2, '0'); // Leden je 0
      var year = now.getFullYear();
  
      return day + '.' + month + '.' + year;
  }
  
  function getFormattedTime() {
      var now = new Date();
      var hours = String(now.getHours()).padStart(2, '0');
      var minutes = String(now.getMinutes()).padStart(2, '0');
      var seconds = String(now.getSeconds()).padStart(2, '0');
  
      return hours + ':' + minutes + ':' + seconds;
  }
  
    fetch('https://script.google.com/macros/s/AKfycbxjt5YisHQCqBuALvLfF9jyGS4pzwlJ3_CWPatB8jrEYqGZ3yAu2xSzp6AfdAeymBPgug/exec', {
      method: 'POST',
      mode: 'no-cors', // Toto vyřeší problém s CORS v tomto kontextu, ale zároveň nebudete moci přijímat odpovědi od serveru
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData)
    }).then(response => {
        console.log(formData)
      console.log('Data byla odeslána');
      $('form.priceActionForm').removeClass('floatingformLoading')
      $('.priceActionForm input').not('[type="submit"]').val('')
      $(this).append('<p class="infoMessage">Děkujeme. Náš kolega vás bude kontaktovat nejbližší pracovní den.</p>')

      // Zde můžete přidat logiku pro zpracování odpovědi
    }).catch(error => {
        $(this).append('<p class="infoMessage">Omlouváme se ale nastala chyba. Zkuste to prosím později.</p>')

        console.error('Error:', error)
    });
});




$(document).on('submit', '.samplesFreeForm', function(a) {
        
    a.preventDefault();
    
    if (!getSessionStorage('formSubmitted')) {  
       
        $(this).addClass('floatingformLoading')
        var formData = {
        jmeno: $('.samplesFreeForm input#nameAndSurname').val(),
        firma: $('.samplesFreeForm input#firm-vat').val(),
        telefon: $('.samplesFreeForm input#phone').val(),
        email: $('.samplesFreeForm input#email').val(),
        formtype: ' POP-UP',
        pageUrl: window.location.href,
        message: $('.samplesFreeForm textarea#message').val(),
        date: getFormattedDate(), // Přidání data odeslání
        time: getFormattedTime()  // Přidání času odeslání
      };
  
      function getFormattedDate() {
        var now = new Date();
        var day = String(now.getDate()).padStart(2, '0');
        var month = String(now.getMonth() + 1).padStart(2, '0'); // Leden je 0
        var year = now.getFullYear();
    
        return day + '.' + month + '.' + year;
    }
    
    function getFormattedTime() {
        var now = new Date();
        var hours = String(now.getHours()).padStart(2, '0');
        var minutes = String(now.getMinutes()).padStart(2, '0');
        var seconds = String(now.getSeconds()).padStart(2, '0');
    
        return hours + ':' + minutes + ':' + seconds;
    }
    
        fetch('https://script.google.com/macros/s/AKfycbxjt5YisHQCqBuALvLfF9jyGS4pzwlJ3_CWPatB8jrEYqGZ3yAu2xSzp6AfdAeymBPgug/exec', {
        method: 'POST',
        mode: 'no-cors', // Toto vyřeší problém s CORS v tomto kontextu, ale zároveň nebudete moci přijímat odpovědi od serveru
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
        }).then(response => {
            console.log(formData)
        console.log('Data byla odeslána');
        $('form.samplesFreeForm').removeClass('floatingformLoading')
        $('.samplesFreeForm input').not('[type="submit"]').val('')
        $(this).append('<p class="infoMessage">Děkujeme. Náš kolega vás bude kontaktovat nejbližší pracovní den.</p>')
        updateSessionStorage('formSubmitted', true);
        clearInterval(intervalId); // Zastaví aktualizaci času po odeslání formuláře
        // Zde můžete přidat logiku pro zpracování odpovědi
        }).catch(error => {
            $(this).append('<p class="infoMessage">Omlouváme se ale nastala chyba. Zkuste to prosím později.</p>')

            console.error('Error:', error)
        });
        
    }
});

$(document).on('submit', 'body>.inquiryFree form.inquiryFreeForm', function(e) {
    e.preventDefault();
    $(this).addClass('floatingformLoading')
    var formData = {
      jmeno: $('body>.inquiryFree form.inquiryFreeForm input#nameAndSurname').val(),
      firma: $('body>.inquiryFree form.inquiryFreeForm input#firm-vat').val(),
      telefon: $('body>.inquiryFree form.inquiryFreeForm input#phone').val(),
      email: $('body>.inquiryFree form.inquiryFreeForm input#email').val(),
      formtype: 'PRODUCT',
      message: $('body>.inquiryFree form.inquiryFreeForm textarea#message').val(),
      pageUrl: window.location.href,
      date: getFormattedDate(), // Přidání data odeslání
      time: getFormattedTime()  // Přidání času odeslání
    };

    function getFormattedDate() {
      var now = new Date();
      var day = String(now.getDate()).padStart(2, '0');
      var month = String(now.getMonth() + 1).padStart(2, '0'); // Leden je 0
      var year = now.getFullYear();
  
      return day + '.' + month + '.' + year;
  }
  
  function getFormattedTime() {
      var now = new Date();
      var hours = String(now.getHours()).padStart(2, '0');
      var minutes = String(now.getMinutes()).padStart(2, '0');
      var seconds = String(now.getSeconds()).padStart(2, '0');
  
      return hours + ':' + minutes + ':' + seconds;
  }
    
  
    fetch('https://script.google.com/macros/s/AKfycbxjt5YisHQCqBuALvLfF9jyGS4pzwlJ3_CWPatB8jrEYqGZ3yAu2xSzp6AfdAeymBPgug/exec', {
      method: 'POST',
      mode: 'no-cors', // Toto vyřeší problém s CORS v tomto kontextu, ale zároveň nebudete moci přijímat odpovědi od serveru
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData)
    }).then(response => {
        console.log(formData)
      console.log('Data byla odeslána');
      $('form.inquiryFreeForm').removeClass('floatingformLoading')
      $('.inquiryFreeForm input').not('[type="submit"]').val('')
      $('.inquiryFreeForm textarea').val('')
      $(this).append('<p class="infoMessage">Děkujeme. Náš kolega vás bude kontaktovat nejbližší pracovní den.</p>')

      // Zde můžete přidat logiku pro zpracování odpovědi
    }).catch(error => {
        $(this).append('<p class="infoMessage">Omlouváme se ale nastala chyba. Zkuste to prosím později.</p>')

        console.error('Error:', error)
    });
});



  setTimeout(function(){
    $('.priceActionBottomRight .infoMessage').remove()
  }, 3500)


  $(document).on('click', '.closeForm', function() {
    updateSessionStorage('formSubmitted', true);
    const formId = $(this).closest('div').find('form').attr('id');
    $(this).closest('div').hide(); // Skryje formulář
    $('#cboxOverlay').hide();
  });

  if($('.type-detail').length){
    $('.cartLine').append('<span class="inquiryButton">Poptat</span>')
    $(document).on('click', '.inquiryButton', function(){
        $('body').append($('.inquiryFree').clone());
        $('#cboxOverlay').show();
    })
  }

$(document).on('click', '.customContactButton', function(){
  $('.priceActionBottomRight').find('.whiteUs').slideToggle()
  $('.priceActionBottomRight').toggleClass('openFormFloating')
})